/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */

import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion, negocioProceso } from '../../conexiones';
import IValidacionProducto from './entidades/validacionProducto';

export default class ModeloCargarPlantilla {
    public async CargarPlantillaProducto(formData: FormData) {
        return manejadorRest<IRespuesta<IValidacionProducto>>(
            () => negocioConfiguracion.post('ProcesarArchivo/CargarPlantillaProducto', formData),
            true
        );
    }

    public async CargarPlantillaMaximoMinimo(formData: FormData) {
        return manejadorRest<IRespuesta<IValidacionProducto>>(
            () => negocioProceso.post('MaximoMinimo/CargarPlantillaMaximoMinimo', formData),
            true
        );
    }

    public async CargarPlantillaInventario(formData: FormData) {
        return manejadorRest<IRespuesta<IValidacionProducto>>(
            () => negocioConfiguracion.post('CargaMasivaInventario/CargarPlantilla', formData),
            true
        );
    }

    

    
}
